module.exports = __webpack_public_path__ + "images/first-board-low-fidelity.782557211e2abb6c5e72.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/first-board-low-fidelity.svg
// module id = on0M
// module chunks = 2